import { ExclamationCircleOutlined } from '@ant-design/icons';
import { FormInstance, Modal, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useBlocker } from 'react-router-dom';

import { t } from '../i18n';

type UseDiscardChangesModal = (
  form: FormInstance
) => [React.Dispatch<React.SetStateAction<boolean>>];

const discardChangesModal = (
  form: FormInstance,
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>
) => {
  return new Promise((resolve) => {
    const modal = Modal.confirm({});
    modal.update({
      title: t('Deseja salvar as alterações?'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <Typography.Text>
          <Trans>
            Você possui modificações em andamento que podem ser perdidas ao sair da página. Você
            deseja:
          </Trans>
        </Typography.Text>
      ),
      cancelText: t('Descartar alterações'),
      cancelButtonProps: {
        onClick: () => {
          setIsDirty(false);
          form.resetFields();
          modal.destroy();
          resolve(true);
        },
      },
      okText: t('Salvar'),
      okButtonProps: {
        onClick: () => {
          setIsDirty(false);
          form.submit();
          modal.destroy();
          resolve(false);
        },
      },
      closable: true,
      maskClosable: true,
    });
  });
};

const useDiscardChangesModal: UseDiscardChangesModal = (form) => {
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    const discardChanges = async () => {
      if (blocker.state === 'blocked' && (await discardChangesModal(form, setIsDirty))) {
        setTimeout(blocker.proceed, 0);
      }
    };

    discardChanges();
  }, [blocker, form]);

  return [setIsDirty];
};

export default useDiscardChangesModal;
